import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { vuetifyBuilder as csVuetifyBuilder } from '@complispace/cs-design-system';

// This is a workaround to use the latest version of vuetify specified in policy-connect package.json
// Date picker in older version of vuetify used in cs-design-system is not working properly
const vuetifyBuilder = (options) => {
  let themeName = 'light';
  if (options) {
    themeName = options.themeName || 'light';
  }
  const helixifyVuetifyDefinitions = csVuetifyBuilder(options).getHelixifyVuetifyDefinitions();

  const vuetifyOptions = {
    components,
    directives,
    theme: { defaultTheme: themeName, themes: helixifyVuetifyDefinitions.theme.themes },
    options: helixifyVuetifyDefinitions.options,
    icons: helixifyVuetifyDefinitions.icons
  };

  return {
    build: () => {
      return createVuetify(vuetifyOptions);
    }
  };
};

export { vuetifyBuilder };
export default vuetifyBuilder;
